import { BaseIngredient } from '@screens/Ingredients/types'

export type LogMealDraftIngredientUpdate = Partial<
  Pick<
    BaseIngredient,
    | 'id'
    | 'description'
    | 'imageUrl'
    | 'calories'
    | 'nutrition'
    | 'servingAmount'
    | 'servingUnits'
    | 'servingOptions'
    | 'thirdPartyIngredientId'
    | 'thirdPartyIngredientSource'
  >
>

const getIngredientValueForDraftKey = (key: string, ingredient: LogMealDraftIngredientUpdate) => {
  switch (key) {
    case 'id':
      return ingredient.id
    case 'description':
    case 'name':
      return ingredient.description
    case 'image_url':
      return ingredient.imageUrl
    case 'calories':
      return ingredient.calories
    case 'nutrition':
      return ingredient.nutrition
    case 'quantity':
    case 'amount':
    case 'serving_amount':
      return ingredient.servingAmount
    case 'unit':
    case 'serving_units':
      return ingredient.servingUnits
    case 'serving_options':
      return ingredient.servingOptions
    case 'third_party_ingredient_id':
      return ingredient.thirdPartyIngredientId
    case 'third_party_ingredient_source':
      return ingredient.thirdPartyIngredientSource
    default:
      return undefined
  }
}

const updateExistingDraftIngredientFields = (
  draftIngredient: Record<string, any>,
  ingredient: LogMealDraftIngredientUpdate,
) =>
  Object.fromEntries(
    Object.entries(draftIngredient).map(([key, currentValue]) => {
      const nextValue = getIngredientValueForDraftKey(key, ingredient)

      return [key, nextValue === undefined ? currentValue : nextValue]
    }),
  )

export const replaceIngredientInLogMealDraft = (
  draft: unknown,
  ingredientId: string,
  ingredient: LogMealDraftIngredientUpdate,
) => {
  if (!draft || typeof draft !== 'object') {
    return draft
  }

  const currentDraft = draft as Record<string, any>

  if (Array.isArray(currentDraft.ingredients)) {
    return {
      ...currentDraft,
      ingredients: currentDraft.ingredients.map((item, index) => {
        if (!item || typeof item !== 'object') {
          return item
        }

        return item?.id === ingredientId ||
          (!item?.id && ingredientId === `log-meal-draft-${index}`)
          ? updateExistingDraftIngredientFields(item, ingredient)
          : item
      }),
    }
  }

  if (
    currentDraft.id === ingredientId ||
    (!currentDraft.id && ingredientId === 'log-meal-draft-0')
  ) {
    return updateExistingDraftIngredientFields(currentDraft, ingredient)
  }

  return currentDraft
}
